module Meevo.Plugins.Product {
    "use strict";
    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;
    import UnitTypeEnum = Meevo.Model.UnitEnum;
    import ProductUsageAmountTypeEnum = Meevo.Model.ProductUsageAmountTypeEnum;
    import ProductPackageTypeEnum = Meevo.Model.ProductPackageTypeEnum;
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    /**
    * Main Section of Client 
    */
    export class ProductUsageSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ProductUsage> {
        generalSettings = {};
        unitTypeEnum = UnitTypeEnum;
        productUsageAmountTypeEnum = ProductUsageAmountTypeEnum;
        displayProductUsage;
        unitEnum = null;
        productUsageCheck;
        productUsageEnum = null;
        businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService;
        clientSettings: Meevo.Plugins.BusinessInfo.IBusinessInfoClientsSettings;
        productUsageTracking;
        hasVariants;
        productContainsAllRetailVariantsOnly: boolean;

        private filterCurrency: any;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            $filter: angular.IFilterService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            protected translateService?: angular.translate.ITranslateService
        ) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);

            this.productUsageTracking = appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking;
            this.filterCurrency = $filter('meevoCurrency') as any;
        }


        dataService: Meevo.Components.BaseClasses.DataServiceBase;


        get storageTypeEnum(): any {
            return StorageTypeEnum;
        }

        sectionModelRetrieved(): void {
            this.getProductUsageCheck(this.model.id);
            this.unitEnum = UnitTypeEnum[this.model.productUnitOfMeasureEnum];
            if (this.model && (this.model.variantUsageSettings == null || this.model.variantUsageSettings.length === 0)) {
                this.model.variantUsageSettings = [];
            }
            else if (this.model.variantUsageSettings.length == 1
                && (this.model.variantUsageSettings[0].displayName == null || this.model.variantUsageSettings[0].displayName == "")) {
                this.hasVariants = Meevo.Model.ObjectStateEnum.Inactive;
            }
            else if (this.model.variantUsageSettings.length >= 1
                && this.model.displayName) {
                this.hasVariants = Meevo.Model.ObjectStateEnum.Active;
            }
            this.productContainsAllRetailVariantsOnly = !this.model.variantUsageSettings.some(v => v.productInventoryType == ProductInventoryTypeEnum.ShopSupply || v.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply);
        }

        getProductUsageCheck = (productId: any) => {

            if (productId != null
                && productId != "") {

                this.dataService.customMethodData(`api/product/${productId}/Usage/Check`, 'GET',null).then((data) => {
                    if (data.data) {
                        this.productUsageCheck = data.data;

                        if (this.productUsageCheck.variantUsageChecking.length > 0) {
                            this.model.variantUsageSettings.forEach((variant) => {
                                var filteredItem = this.productUsageCheck.variantUsageChecking.filter(x => x.variantId == variant.id)[0];
                                if (filteredItem) {
                                    variant.hasUsage = filteredItem.hasUsage;
                                }                             
                            });
                        }
                    }
                });
            }
        }

        canUpdateProduct = () => {
            var canUpdate = true;
            if (this.productUsageCheck) {
                if (this.productUsageCheck.variantUsageChecking.length > 0) {
                    for (var i = 0; i < this.productUsageCheck.variantUsageChecking.length; i++) {
                        if (this.productUsageCheck.variantUsageChecking[i].hasUsage) {
                            canUpdate = false;
                            break;
                        }
                    }
                }
            }
            return canUpdate;
        }

        onBlurQty = (index) => {
            if (this.model.variantUsageSettings[index]) {
                if (this.model.variantUsageSettings[index].unitOfMeasureQuantity <= 0) {
                    this.model.variantUsageSettings[index].unitOfMeasureQuantity = null;
                }
            }
        }

        getPricingDescription = (variantUsage: Meevo.Model.VariantUsageSetting) => {
            var desc: string = '';
            try {
                switch (variantUsage.chargeType) {
                    case Meevo.Model.ProductVariantChargeTypeEnum.FlatFee:
                        desc = this.translateService.instant('LABEL_USAGETRACK_PRICING_FLAT_FEE_DESCRIPTION', { price: this.filterCurrency(variantUsage.chargeAmount) });
                        break;
                    case Meevo.Model.ProductVariantChargeTypeEnum.PerUnit:
                        let unitOfMeasureLabel = (this.model.productUsageType == ProductUsageAmountTypeEnum.PartialAmount && this.model.productUnitOfMeasureEnum) ? "ENUM_LABEL_" + this.model.productUnitOfMeasureEnum : "LABEL_USAGETRACK_PRODUCT";
                        desc = this.translateService.instant('LABEL_USAGETRACK_PRICING_PER_PRODUCT_DESCRIPTION', { price: this.filterCurrency(variantUsage.chargeAmount), unit: this.translateService.instant(unitOfMeasureLabel) });
                        break;
                    case Meevo.Model.ProductVariantChargeTypeEnum.None:
                    default:
                        desc = this.translateService.instant('LABEL_USAGETRACK_PRICING_NONE_DESCRIPTION');
                        break;
                }
            }
            catch (e) { console.log(e); }
            return desc;
        }

        setVariantUsagePricing(event, variantUsage: Meevo.Model.VariantUsageSetting, ndx: number): void {
            event.stopPropagation();
            var modalOptions: VariantAdjustUsagePricingOptions = {
                product: this.model,
                variant: variantUsage
            };
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/product/modals/variantAdjustUsagePricing.template.html",
                controller: "meevo.plugins.product.VariantAdjustUsagePricingController",
                controllerAs: "vm",
                bindToController: true,
                escapeToClose: true,
                locals: {
                    options: modalOptions
                }
            }
            this.modalService.showCustom(options);
        }

    }
}